import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import YouTube from "react-youtube";
import { getCookie } from "../EnhancedComponentOL/utils";
export default function SingleVideo() {
  const [link, setLink] = useState(null);
  const [userDetail, setUserDetails] = useState(null);
  const [mode, setMode] = useState(null);
  const [volume, setVolume] = useState(100);
  const [isMuted, setIsMuted] = useState(false);
  const [isPlaying, setIsPlaying] = useState(true);
  const [player, setPlayer] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const query = new URLSearchParams(window.location.search);
      const eventId = query.get("EventId");
      const modeFromUrl = query.get("mode");

      if (eventId && modeFromUrl) {
        setMode(modeFromUrl);
        try {
          const response = await axios.post("/VideoDetails.php", {
            Id: eventId,
            Type: "AudioVideo",
          });
          const { status, Link } = response.data.data;

          if (status === "invalid") {
            showError("Something went wrong! Event does not exist");
          } else if (status === "valid") {
            console.log("Video ID:", Link);
            const videoId = Link.includes("watch?v=")
              ? Link.split("v=")[1].split("&")[0]
              : Link;
            setLink(videoId);
          } else {
            showError("Something went wrong & Data not found!");
          }
        } catch (error) {
          console.error("Error fetching video details:", error);
          showError("An error occurred while fetching video details");
        }
      }

      try {
        const its = getCookie("ITS_ID");
        const response = await axios.post("/UserDetails.php", { ITS: its });
        setUserDetails(response.data.phpresult || {});
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };

    fetchData();

    // Add keydown event listener for Esc key to exit fullscreen
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && isFullscreen) {
        setIsFullscreen(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isFullscreen]);

  const showError = (message) => {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: message,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.replace("/ActiveEvents");
      }
    });
  };

  const onYouTubeReady = (event) => {
    console.log("Player is ready");
    const playerInstance = event.target;
    playerInstance.setVolume(volume);
    playerInstance.playVideo();
    setPlayer(playerInstance);
    setIsPlaying(true);
    setIsLoading(false);
  };

  const onStateChange = (event) => {
    setIsPlaying(event.data === 1); // 1 means playing
    if (event.data === -1) {
      setIsLoading(false);
    }
  };

  const onError = (error) => {
    console.error("YouTube Player Error:", error);
    setIsLoading(false);
    showError("Failed to load the video. Please try again later.");
  };

  const handleVolumeChange = (event) => {
    const newVolume = parseInt(event.target.value, 10);
    setVolume(newVolume);
    if (player) {
      player.setVolume(newVolume);
      if (newVolume > 0 && isMuted) {
        player.unMute();
        setIsMuted(false);
      }
    }
  };

  const toggleMute = () => {
    if (player) {
      if (isMuted) {
        player.unMute();
        setIsMuted(false);
      } else {
        player.mute();
        setIsMuted(true);
      }
    }
  };

  const togglePlayPause = () => {
    if (player) {
      if (isPlaying) {
        player.pauseVideo();
        setIsPlaying(false);
      } else {
        player.playVideo();
        setIsPlaying(true);
      }
    }
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  const youtubeOpts = {
    height: "100%", // Set to 100% to fill container
    width: "100%",
    playerVars: {
      autoplay: 1,
      controls: 0,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      disablekb: 1,
      iv_load_policy: 3,
      fs: 0,
      playsinline: 1,
    },
  };

  return (
    <div id="wrapper">
      <div id="content-wrapper">
        <div className="container-fluid pb-0">
          <div className="top-category section-padding mb-4">
            <div className="row">
              <div className="col-md-12">
                <div className="main-title">
                  <div
                    className="btn-group float-right right-action"
                    style={{ color: "white", fontWeight: "bolder" }}
                  >
                    Name: {userDetail?.Name || ""}
                    <br />
                    Area/Jamaat: {userDetail?.Area || ""}
                    <br />
                    Device: {userDetail?.device_info || ""}
                  </div>
                  <h6 style={{ color: "white" }}>Haidery Masjid - Bhopal</h6>
                </div>
              </div>
            </div>
          </div>

          <div className="video-block section-padding">
            <div className="row">
              <div className="col-xl-12">
                <div className="text-center mb-3">
                  <button onClick={toggleFullscreen} className="btn btn-danger">
                    {isFullscreen
                      ? "Exit Fullscreen"
                      : mode === "AudioVideo"
                      ? "Enter Video Fullscreen"
                      : "Enter Audio Fullscreen"}
                  </button>
                </div>
              </div>
              {link ? (
                <div className="col-xl-12 col-sm-12 mb-3">
                  <div
                    className="media-container"
                    style={{
                      position: "relative",
                      maxWidth: "100%",
                      width: isFullscreen ? "100vw" : "100%",
                      height: isFullscreen
                        ? "100vh"
                        : mode === "Audio"
                        ? "100px"
                        : "calc(100vh - 200px)",
                      top: isFullscreen ? 0 : "auto",
                      left: isFullscreen ? 0 : "auto",
                      right: isFullscreen ? 0 : "auto",
                      bottom: isFullscreen ? 0 : "auto",
                      zIndex: isFullscreen ? 9999 : "auto",
                      position: isFullscreen ? "fixed" : "relative",
                      backgroundColor: isFullscreen ? "#000" : "transparent",
                    }}
                  >
                    {isLoading && (
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#000",
                          color: "#fff",
                        }}
                      >
                        Loading...
                      </div>
                    )}
                    <div
                      style={{
                        display: isLoading ? "none" : "block",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <YouTube
                        videoId={link}
                        opts={youtubeOpts}
                        onReady={onYouTubeReady}
                        onStateChange={onStateChange}
                        onError={onError}
                        style={{
                          border: "none",
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor:
                          mode === "Audio" ? "black" : "transparent",
                        pointerEvents: "auto", // Block all clicks
                        zIndex: 1,
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        console.log("Overlay click blocked");
                      }}
                    >
                      {mode === "Audio" && (
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "white",
                            fontSize: "20px",
                            textAlign: "center",
                          }}
                        >
                          Audio Only
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        bottom: "10px",
                        left: "10px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        zIndex: 2,
                      }}
                    >
                      <input
                        type="range"
                        min="0"
                        max="100"
                        value={volume}
                        onChange={handleVolumeChange}
                        style={{ width: "100px" }}
                      />
                      <button
                        onClick={toggleMute}
                        className="btn btn-sm btn-outline-light"
                      >
                        {isMuted ? "Unmute" : "Mute"}
                      </button>
                      <button
                        onClick={togglePlayPause}
                        className="btn btn-sm btn-outline-light"
                      >
                        {isPlaying ? "Pause" : "Play"}
                      </button>
                      <span
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            width: "10px",
                            height: "10px",
                            backgroundColor: "red",
                            borderRadius: "50%",
                            marginRight: "5px",
                          }}
                        ></span>
                        Live
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-xl-12 col-sm-12 mb-3">
                  <div className="alert alert-danger" role="alert">
                    Unable to load {mode === "AudioVideo" ? "video" : "audio"}.
                    Please try again later.
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
